import React, { useEffect, useState } from "react";
import classes from "./styles.module.scss";

const CountdownTimer = ({ validTill }) => {
    const [timeLeft, setTimeLeft] = useState(null);

    useEffect(() => {
        const calculateTimeLeft = () => {
            const now = new Date();
            const expiry = new Date(validTill);
            const diff = expiry - now;

            if (diff <= 0) {
                setTimeLeft(null);
                return;
            }

            const millisecondsInDay = 1000 * 60 * 60 * 24;
            const totalDays = Math.floor(diff / millisecondsInDay);

            const months = Math.floor(totalDays / 30);
            const days = totalDays % 30;

            const result =
                (months > 0 ? `${months} Month${months > 1 ? "s" : ""} ` : "") +
                (days > 0 ? `${days} Day${days > 1 ? "s" : ""}` : "");

            setTimeLeft(result.trim());
        };

        calculateTimeLeft();
    }, [validTill]);

    return (
        <div className={classes.expiresIn}>
            {timeLeft ? `Expire In ${timeLeft}` : "Expired"}
        </div>
    );
};

export default CountdownTimer;
